import { ArrowRight } from '@styled-icons/feather/ArrowRight';
import { useRouter } from 'next/router';
import { Card, SubTitle, Paragraph } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

const Meta = tw.small`
  block
  text-slate-400
`;

const PolicyExcerpt = ({ author, date, description, fileName, slug, title }) => {
  const router = useRouter();

  const actions = [{
    align: 'right',
    icon: <ArrowRight />,
    iconPosition: 'right',
    label: 'View Policy',
    onClick: () => router.push(`/policies/${fileName}`),
  }];

  return (
    <Card
      actions={actions}
      className="border-t-slate-50 h-full"
      header={
        <SubTitle className="text-brand-primary px-4 pt-4">
          {title}
        </SubTitle>
      }
    >
      <Meta>Posted by {author} on {date}</Meta>
      <Paragraph>{description}</Paragraph>
    </Card>
  );
};

export default PolicyExcerpt;
